// extracted by mini-css-extract-plugin
export default {"caption":"XaoM8","label":"vqH2F"};